import { useQueryClient } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "@/hooks/store-hooks";
import usePageTracking from "@/hooks/usePageTracking";
import { useEffect } from "react";
import { AdminLayout } from "../Layout/admin.layout";

const VALID_JWT_TOKEN_REGEX = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/;

export const GuardRoute = () => {
  const jwtToken = useAppSelector((state) => state.auth.accessToken);
  const user = useAppSelector((state) => state.auth.user);
  const organization = useAppSelector((state) => state.auth.organization);
  const queryClient = useQueryClient();
  const { setUserId, setUserProperties } = usePageTracking();

  useEffect(() => {
    if (user?._id) {
      setUserId(user._id);

      const userProperties: Record<string, string | number> = {
        user_email: user.email,
        is_super_admin: user.isSuperAdmin ? "yes" : "no",
        has_organization: organization ? "yes" : "no",
        organizations_count: user.organizations?.length || 0
      };

      if (organization?._id) {
        userProperties.organization_id = organization._id;
        userProperties.organization_name = organization.name;
      }

      setUserProperties(userProperties);
    }
  }, [user, organization, setUserId, setUserProperties]);

  if (!jwtToken || !VALID_JWT_TOKEN_REGEX.test(jwtToken)) {
    queryClient.clear();
    return <Navigate to="/auth/signin" replace />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
};

export default GuardRoute;
